import * as React from 'react';
import AddressForm from './AddressForm';
import AddressList from "./AddressList"
import { Box } from '@mui/material';
import { AddressContext, useContext } from './AddressContext';


export const AddressTabContent = () => {

    return (<Box display="flex" justifyContent="space-between" width="100%">

        <AddressContext.Provider value={useContext()}>
            <AddressForm sx={{ width: "60%" }} />
            <AddressList sx={{ width: "35%" }} />
        </AddressContext.Provider>
        
    </Box>)
}


